<template>
  <div
    class="normal-tag"
    :style="{
      background: userLevel?.background,
      color: userLevel?.textColor,
    }"
    :class="isDark ? 'text-black-1' : 'text-white'"
  >
    <iconpark-icon v-if="icon && userLevel?.icon" :name="userLevel?.icon" size="18"></iconpark-icon>
    <template v-if="$slots.default">
      <slot />
    </template>
    <span v-else> {{ userLevel?.name }}</span>
  </div>
</template>
<script lang="ts" setup>
import type { PropType } from 'vue';
import type { LevelInfo } from '@/constants';
import { USER_LEVEL_KEY } from '~/api/interface';

const props = defineProps({
  userLevel: {
    type: Object as PropType<LevelInfo>,
  },
  icon: Boolean,
});

const isDark = computed(
  () =>
    props.userLevel?.userLevelKey &&
    [USER_LEVEL_KEY.TASTE, USER_LEVEL_KEY.TEAM_TASTE].includes(props.userLevel.userLevelKey),
);
</script>
<style lang="scss" scoped>
.normal-tag {
  @apply rounded-[8px] text-[12px] flex-y-center justify-center px-[5px];
  white-space: nowrap;
}
</style>
